var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "menu-main" },
    [
      _c(
        "el-menu",
        {
          staticClass: "el-menu-vertical-demo",
          attrs: {
            "background-color": "#f8fbff",
            "text-color": "#5f6f8f",
            "active-text-color": "#2f436d",
            "unique-opened": true,
            "default-active": _vm.activeMenuIndex,
            "default-openeds": _vm.openSubMenu,
          },
          on: { select: _vm.handleMenuSelect },
        },
        [
          _c(
            "router-link",
            { staticClass: "router-link", attrs: { to: "/dashboard" } },
            [
              _c(
                "el-menu-item",
                { staticClass: "menu-logo-item", attrs: { index: "1" } },
                [
                  _c("i", { staticClass: "el-icon-s-home menu-logo-icon" }),
                  _c(
                    "span",
                    {
                      staticClass: "onekids-title",
                      attrs: { slot: "title" },
                      slot: "title",
                    },
                    [_vm._v("ONEKIDS TEACHER")]
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "el-submenu",
            {
              staticClass: "menu-group-news",
              attrs: { index: "9" },
              scopedSlots: _vm._u([
                {
                  key: "title",
                  fn: function () {
                    return [
                      _c("i", { staticClass: "el-icon-notebook-2" }),
                      _c("span", { staticClass: "title_nav" }, [
                        _vm._v("\n          Bảng tin\n        "),
                      ]),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _c(
                "router-link",
                {
                  staticClass: "router-link",
                  attrs: { to: "/notifihis/notify-teacher" },
                },
                [
                  _c(
                    "el-menu-item",
                    {
                      attrs: { index: "2-10" },
                      on: {
                        click: function ($event) {
                          return _vm.changeBreadcrumbMethod(
                            "notifihis-notify-teacher"
                          )
                        },
                      },
                    },
                    [_vm._v("Tin tức lớp học\n        ")]
                  ),
                ],
                1
              ),
              _c(
                "router-link",
                {
                  staticClass: "router-link",
                  attrs: { to: "/appsend/parent-feedback" },
                },
                [
                  _vm.checkPermission(["news_feedbackParent"])
                    ? _c(
                        "el-menu-item",
                        {
                          attrs: { index: "2-3" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod(
                                "appsend-parent-feedback"
                              )
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "wrap_title_nav" }, [
                            _c("span", [_vm._v("Phụ huynh góp ý")]),
                            _vm.parentFeedback > 0
                              ? _c("div", { staticClass: "notification_nav" }, [
                                  _vm._v(_vm._s(_vm.parentFeedback)),
                                ])
                              : _vm._e(),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "router-link",
                {
                  staticClass: "router-link",
                  attrs: { to: "/appsend/teacher-feedback" },
                },
                [
                  _vm.checkPermission(["news_feedbackTeacher"])
                    ? _c(
                        "el-menu-item",
                        {
                          attrs: { index: "2-4" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod(
                                "appsend-teacher-feedback"
                              )
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "wrap_title_nav" }, [
                            _c("span", [_vm._v("Giáo viên góp ý")]),
                            _vm.teacherFeedback > 0
                              ? _c("div", { staticClass: "notification_nav" }, [
                                  _vm._v(_vm._s(_vm.teacherFeedback)),
                                ])
                              : _vm._e(),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "router-link",
                {
                  staticClass: "router-link",
                  attrs: { to: "/survey_form/manager" },
                },
                [
                  _vm.checkPermission(["news_survey"])
                    ? _c(
                        "el-menu-item",
                        {
                          attrs: { index: "2-5" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod(
                                "survey-form-manager"
                              )
                            },
                          },
                        },
                        [_vm._v("\n          Phiếu khảo sát\n        ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-submenu",
            {
              staticClass: "menu-group-diary",
              attrs: { index: "2" },
              scopedSlots: _vm._u([
                {
                  key: "title",
                  fn: function () {
                    return [
                      _c("i", { staticClass: "el-icon-reading" }),
                      _c("span", [_vm._v("Nhật ký phụ huynh")]),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _c(
                "router-link",
                {
                  staticClass: "router-link",
                  attrs: { to: "/parentdiary/message-parent" },
                },
                [
                  _vm.checkPermission(["parentDiary_message"])
                    ? _c(
                        "el-menu-item",
                        {
                          attrs: { index: "2-1" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod(
                                "parentdiary-message-parent"
                              )
                            },
                          },
                        },
                        [_vm._v("Lời nhắn\n      ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "router-link",
                {
                  staticClass: "router-link",
                  attrs: { to: "/parentdiary/medicine" },
                },
                [
                  _vm.checkPermission(["parentDiary_medicine"])
                    ? _c(
                        "el-menu-item",
                        {
                          attrs: { index: "2-2" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod(
                                "parentdiary-medicine"
                              )
                            },
                          },
                        },
                        [_vm._v("Dặn thuốc\n      ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "router-link",
                {
                  staticClass: "router-link",
                  attrs: { to: "/parentdiary/take-leave" },
                },
                [
                  _vm.checkPermission(["parentDiary_absenLetter"])
                    ? _c(
                        "el-menu-item",
                        {
                          attrs: { index: "2-3" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod(
                                "parentdiary-take-leave"
                              )
                            },
                          },
                        },
                        [_vm._v("Xin nghỉ\n      ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "router-link",
                {
                  staticClass: "router-link",
                  attrs: { to: "/absent_letter/daily" },
                },
                [
                  _vm.checkPermission(["absent_letter_v4"])
                    ? _c(
                        "el-menu-item",
                        {
                          attrs: { index: "2-6" },
                          on: {
                            click: function ($event) {
                              return _vm.changeBreadcrumbMethod(
                                "absent-letter_v4"
                              )
                            },
                          },
                        },
                        [_vm._v("Xin nghỉ\n      ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm.checkPermission(["kids"])
            ? _c(
                "el-submenu",
                {
                  staticClass: "menu-group-student",
                  attrs: { index: "3" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "title",
                        fn: function () {
                          return [
                            _c("i", { staticClass: "el-icon-user-solid" }),
                            _c("span", [_vm._v("Quản lý học sinh")]),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    3412976665
                  ),
                },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: { to: "/student/students" },
                    },
                    [
                      _vm.checkPermission(["kids_list"])
                        ? _c(
                            "el-menu-item",
                            {
                              attrs: { index: "3-1" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "student-students"
                                  )
                                },
                              },
                            },
                            [_vm._v("Danh sách học sinh\n      ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.checkPermission([
            "studentQuality",
            "attendance_v4",
            "student-evaluation-v4",
          ])
            ? _c(
                "el-submenu",
                {
                  staticClass: "menu-group-quality",
                  attrs: { index: "4" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "title",
                        fn: function () {
                          return [
                            _c("i", {
                              staticClass: "el-icon-document-checked",
                            }),
                            _c("span", [_vm._v("Chất lượng học sinh")]),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    1210448617
                  ),
                },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: { to: "/student-quality/attendance" },
                    },
                    [
                      _vm.checkPermission(["studentQuality_attendance"])
                        ? _c(
                            "el-menu-item",
                            {
                              attrs: { index: "4-1" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "student-quality-attendance"
                                  )
                                },
                              },
                            },
                            [_vm._v("Điểm danh\n      ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: { to: "/student-quality/attendance/v2" },
                    },
                    [
                      _vm.checkPermission(["studentQuality_attendance_v2"])
                        ? _c(
                            "el-menu-item",
                            {
                              attrs: { index: "4-2" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "student-quality-attendance_v2"
                                  )
                                },
                              },
                            },
                            [_vm._v("Điểm danh\n      ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: { to: "/attendance/daily" },
                    },
                    [
                      _vm.checkPermission(["attendance_v4"])
                        ? _c(
                            "el-menu-item",
                            {
                              attrs: { index: "4-8" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "attendance-v4"
                                  )
                                },
                              },
                            },
                            [_vm._v("Điểm danh\n      ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: { to: "/student-quality/evaluate" },
                    },
                    [
                      _vm.checkPermission(["studentQuality_evaluate"])
                        ? _c(
                            "el-menu-item",
                            {
                              attrs: { index: "4-3" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "student-quality-evaluate"
                                  )
                                },
                              },
                            },
                            [_vm._v("Nhận xét\n      ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: { to: "/evaluation-v4" },
                    },
                    [
                      _vm.checkPermission(["student-evaluation-v4"])
                        ? _c(
                            "el-menu-item",
                            {
                              attrs: { index: "4-9" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "student-evaluation-v4"
                                  )
                                },
                              },
                            },
                            [_vm._v("Nhận xét\n      ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "router-link",
                    { staticClass: "router-link", attrs: { to: "/album-v2" } },
                    [
                      _vm.checkPermission(["studentQuality_ablum"])
                        ? _c(
                            "el-menu-item",
                            {
                              attrs: { index: "4-4" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "student-quality-album"
                                  )
                                },
                              },
                            },
                            [_vm._v("Album ảnh\n      ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: { to: "/student-quality/height-weight" },
                    },
                    [
                      _vm.checkPermission(["studentQuality_heightWeight"])
                        ? _c(
                            "el-menu-item",
                            {
                              attrs: { index: "4-5" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "student-quality-height-weight"
                                  )
                                },
                              },
                            },
                            [_vm._v("Chiều cao, cân nặng\n      ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: { to: "/student-quality/schedule" },
                    },
                    [
                      _vm.checkPermission(["studentQuality_schedule"])
                        ? _c(
                            "el-menu-item",
                            {
                              attrs: { index: "4-6" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "student-quality-schedule"
                                  )
                                },
                              },
                            },
                            [_vm._v("Thời khóa biểu\n      ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: { to: "/student-quality/class-menu" },
                    },
                    [
                      _vm.checkPermission(["studentQuality_menu"])
                        ? _c(
                            "el-menu-item",
                            {
                              attrs: { index: "4-7" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "student-quality-class-menu"
                                  )
                                },
                              },
                            },
                            [_vm._v("Thực đơn\n      ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-submenu",
            {
              staticClass: "menu-group-chart",
              attrs: { index: "5" },
              scopedSlots: _vm._u([
                {
                  key: "title",
                  fn: function () {
                    return [
                      _c("i", { staticClass: "el-icon-s-data" }),
                      _c("span", [_vm._v("Thống kê")]),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _c(
                "router-link",
                {
                  staticClass: "router-link",
                  attrs: { to: "/chart/statistical/attendance" },
                },
                [
                  _c(
                    "el-menu-item",
                    {
                      attrs: { index: "5-1" },
                      on: {
                        click: function ($event) {
                          return _vm.changeBreadcrumbMethod(
                            "chart-statistical-attendance"
                          )
                        },
                      },
                    },
                    [_vm._v("Điểm danh\n      ")]
                  ),
                ],
                1
              ),
              _c(
                "router-link",
                {
                  staticClass: "router-link",
                  attrs: { to: "/chart/statistical/evaluate" },
                },
                [
                  _c(
                    "el-menu-item",
                    {
                      attrs: { index: "5-2" },
                      on: {
                        click: function ($event) {
                          return _vm.changeBreadcrumbMethod(
                            "chart-statistical-evaluate"
                          )
                        },
                      },
                    },
                    [_vm._v("Nhận xét\n      ")]
                  ),
                ],
                1
              ),
              _c(
                "router-link",
                {
                  staticClass: "router-link",
                  attrs: { to: "/chart/statistical/album" },
                },
                [
                  _c(
                    "el-menu-item",
                    {
                      attrs: { index: "5-3" },
                      on: {
                        click: function ($event) {
                          return _vm.changeBreadcrumbMethod(
                            "chart-statistical-album"
                          )
                        },
                      },
                    },
                    [_vm._v("Album ảnh\n      ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm.checkPermission(["statisticalCommon"])
            ? _c(
                "el-submenu",
                {
                  staticClass: "menu-group-common",
                  attrs: { index: "6" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "title",
                        fn: function () {
                          return [
                            _c("i", { staticClass: "el-icon-s-operation" }),
                            _c("span", [_vm._v("Thống kê chung")]),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    2165048643
                  ),
                },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: { to: "/teacher/statistical" },
                    },
                    [
                      _vm.checkPermission(["statisticalCommon_attendance"])
                        ? _c(
                            "el-menu-item",
                            {
                              attrs: { index: "6-1" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "teacher-statistical"
                                  )
                                },
                              },
                            },
                            [_vm._v("\n        Thống kê điểm danh\n      ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.checkPermission(["birthday"])
            ? _c(
                "el-submenu",
                {
                  staticClass: "menu-group-birthday",
                  attrs: { index: "7" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "title",
                        fn: function () {
                          return [
                            _c("i", { staticClass: "el-icon-burger" }),
                            _c("span", [_vm._v("Quản lý sinh nhật")]),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    1762041684
                  ),
                },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: { to: "/birthday/kids" },
                    },
                    [
                      _vm.checkPermission(["birthday_kids"])
                        ? _c(
                            "el-menu-item",
                            {
                              attrs: { index: "7-1" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "birthday-kids"
                                  )
                                },
                              },
                            },
                            [_vm._v("Sinh nhật học sinh\n      ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "router-link",
                    {
                      staticClass: "router-link",
                      attrs: { to: "/birthday/parent" },
                    },
                    [
                      _vm.checkPermission(["birthday_parent"])
                        ? _c(
                            "el-menu-item",
                            {
                              attrs: { index: "7-2" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeBreadcrumbMethod(
                                    "birthday-parent"
                                  )
                                },
                              },
                            },
                            [_vm._v("Sinh nhật phụ huynh\n      ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-submenu",
            {
              staticClass: "menu-group-support",
              attrs: { index: "8" },
              scopedSlots: _vm._u([
                {
                  key: "title",
                  fn: function () {
                    return [
                      _c("i", { staticClass: "el-icon-question" }),
                      _c("span", [_vm._v("Hỗ trợ & hướng dẫn")]),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            _vm._l(_vm.supportList, function (item) {
              return _c(
                "a",
                {
                  key: item.name,
                  staticClass: "router-link",
                  staticStyle: { display: "block" },
                  attrs: { href: item.link, target: "_blank" },
                },
                [
                  _c("el-menu-item", { attrs: { index: item.name } }, [
                    _vm._v(_vm._s(item.name)),
                  ]),
                ],
                1
              )
            }),
            0
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }